import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';

//import http from "../../Redux/Services/http-common";
//import { Logout } from "../../Redux/Action/userActions";
import {  useNavigate } from "react-router-dom";
// import hospitalservice from "../../Redux/Services/hospitalservice";
import axios from "axios";
// import { trackSignupEvent } from "../utils/analytics/events";


const SignupForm = (props) => {
  const [err, setErr] = useState({});
  const [msg, setMsg] = useState("");

  const toast = React.useRef(null);

  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(true);
  const [activeTab, setActiveTab] = useState("terms");
  const [showConsent, setShowConsent] = useState(false);
//   const userData = useSelector((state) => state.authReducer.patientData);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
//   const { patientSession } = userData;
  const [tcCheck, settcCheck] = useState(false);
  const [privacyCheck, setPrivacyCheck] = useState(false);
  const [consentInfo, setConsentInfo] = useState({
    privacyPdf: "",
    privacyVersion: "",
    tcPdf: "",
    tcVersion: ""
  });
  const [stateList, setstateList] = useState([""]);

  const isValidMobile = /^[6-9]\d{9}$/.test(props.mobile);
  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(props.mobile);

  const [formData, setformData] = useState({
    mobile: isValidMobile ? props.mobile : "",
    email: isValidEmail ? props.mobile : "",
    firstName: "",
    lastName: "",
    dob: null
  });

  const [width, setWidth] = useState(window.innerWidth);
  const [vh, setVh] = useState(window.innerHeight * 0.01);

  useEffect(() => {
    const updateVh = () => {
      setVh(window.innerHeight * 0.01);
    };

    updateVh();
    window.addEventListener('resize', updateVh);
    return () => window.removeEventListener('resize', updateVh);
  }, []);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  let modalWidth;
  if (width <= 767) {
    modalWidth = '100%';
  } else if (width >= 768 && width <= 1023) {
    modalWidth = '500px';
  } else {
    modalWidth = '600px';
  }

  function allValuesAreEmpty(obj) {
    for (const key in obj) {
      if (
        Object.prototype.hasOwnProperty.call(obj, key) &&
        obj[key].trim() !== ""
      ) {
        return false;
      }
    }
    return true;
  }

  const showToast = (severity, summary, detail) => {
    if (toast.current) {
      toast.current.show({ severity, summary, detail });
    }
  };

  const getVersion = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_NEWBASEURL}ConsentVersion/list/filter?userType=PATIENT_B2C`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data?.data, "consent");
      let info = {
        privacyPdf: data?.data[1].consentFile,
        privacyVersion: data?.data[1].versionNumber,
        tcPdf: data?.data[0].consentFile,
        tcVersion: data?.data[0].versionNumber,
      };
      setConsentInfo(info);
    } catch (e) {
      console.log("Error fetching data:", e);
    }
  };

  useEffect(() => {
    getVersion();
  }, []);



  const signUp = async () => {
    let error = {};
    error.firstName = formData.firstName ? "" : "Please Enter FirstName";
    error.lastName = formData.lastName ? "" : "Please Enter lastName";
    error.mobile = formData.mobile ? "" : "Please Enter Mobile No";
    error.dob = formData.dob ? "" : "Please Select DOB";

    if (!allValuesAreEmpty(error)) {
      console.log(allValuesAreEmpty(error), error, formData, "doihouvgduhdv ");
      setErr(error);
      return;
    }

    if (!tcCheck || !privacyCheck) {
      showToast('error', 'Error', 'Please accept both terms and condition and privacy policy!');
      return;
    }

    setIsLoading(true);
    let payload = {
      email: formData.email,
      firstName: formData.firstName,
      dob: formData.dob ? new Date(formData.dob).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3') : "",
      lastName: formData.lastName,
      mobileNumber: formData.mobile,
    };
    
    console.log(payload, "Registration payload");
    setMsg("");
     const token = sessionStorage.getItem("token");
        const headers = {
            "Content-Type": "application/json",
        };

        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
    
    try {
    
      const response = await fetch(`${process.env.REACT_APP_BASEURL}patient-user/register`, 
         {
                method: "POST",
                headers: headers,
                body: JSON.stringify(payload),
            }
        );
      console.log("Registration result:", response);
      
      const responseData = await response.json();
      
      if (!response.ok) {
        setIsLoading(false);
        showToast('error', 'Error', responseData.message || 'Registration failed');
        setMsg(responseData.message || 'Registration failed');
        return;
      }

      try {
        console.log("Making consent API call...");
        const consentPayload = {
          createdBy: "CUREBAYADMIN",
          privacyPolicyConsent: 1,
          sourceChannel: "B2C",
          status: 1,
          termsAndConditionConsent: 1,
          type: "P",
          patientId: responseData?.data?.patientCode,
          privacyVersionNumber: consentInfo.privacyVersion,
          tcVersionNumber: consentInfo.tcVersion,
        }
        const consentResponse = await fetch(
          `${process.env.REACT_APP_NEWBASEURL}PatientConsent/addPatientConsent`,
           {
                method: "POST",
                headers: headers,
                body: JSON.stringify(consentPayload),
            }
         
        );
        console.log("Consent API success:", consentResponse);
      } catch (consentError) {
        console.error("Consent API failed:", consentError);
      }

      showToast('success', 'Success', 'You are successfully registered!');
      setMsg("You are successfully registered!");

      try {
        const modifiedData = {
          ...responseData.data,
          code: responseData.data.patientCode,
          sessionid: responseData.data.sessionId,
          firstname: responseData.data.firstName,
          lastname: responseData.data.lastName,
          firstName: responseData.data.firstName,
          lastName: responseData.data.lastName,
          email: formData.email,
          mobileNumber: formData.mobile,
        };
        delete modifiedData.patientCode;
        delete modifiedData.sessionId;

        console.log("Modified data:", modifiedData);

        // Store authentication data
        localStorage.setItem("loginstatus", "true");
        localStorage.setItem("token", responseData.data.authToken || responseData.data.token);
        localStorage.setItem("loginObj", JSON.stringify(modifiedData));

        // IMPORTANT: Trigger a custom event to notify hooks about login
        window.dispatchEvent(new CustomEvent('loginComplete', { 
          detail: { loginData: modifiedData } 
        }));

        const { code: userId, firstName, lastName } = modifiedData;
        
        if (window.webengage && window.webengage.user) {
          console.log("Setting WebEngage attributes...");
          window.webengage.user.login(userId);
          window.webengage.user.setAttribute("we_whatsapp_opt_in", true);
            
          const email = formData.email?.trim();
          if (email && /^\S+@\S+\.\S+$/.test(email)) {
            window.webengage.user.setAttribute("we_email", email);
          }
            
          const phone = formData.mobile;
          if (/^[6-9]\d{9}$/.test(phone)) {
            window.webengage.user.setAttribute("we_phone", `+91${phone}`);
          }
            
          if (formData.firstName) {
            window.webengage.user.setAttribute("we_first_name", formData.firstName);
          }
            
          if (formData.lastName) {
            window.webengage.user.setAttribute("we_last_name", formData.lastName);
          }
            
          console.log("WebEngage attributes set successfully");
        }
      } catch (storageError) {
        console.error("Storage/WebEngage error:", storageError);
      }

      setIsLoading(false);

      try {
        props.setIsModalOpenLogin(false);
        navigate('/');
        
        // if (typeof trackSignupEvent === 'function') {
        //   trackSignupEvent();
        // }
      } catch (navigationError) {
        console.error("Navigation error:", navigationError);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Registration error:", error);
      
      if (error.response?.data?.details && error.response.data.details.length > 0) {
        showToast('error', 'Error', error.response.data.details[0]);
      } else if (error.response?.data?.message) {
        showToast('error', 'Error', error.response.data.message);
      } else if (error.message) {
        showToast('error', 'Error', error.message);
      } else {
        showToast('error', 'Error', 'An error occurred during signup.');
      }
    }
  };

  const handleChange = (e) => {
    console.log("Event:", e);
    if (e?.target?.value?.length === 0) {
      setErr("");
    }

    if (e?.target?.name) {
      console.log(e.target.value, "dsvosdvoisdhivpds");
      setformData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleDateChange = (e) => {
    setformData({ ...formData, dob: e.value });
  };

  const contactUs = () => {
    props.modalClose();
  };

  const handleClick = () => {
    setShowConsent(!showConsent);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const showModal2 = () => {
    console.log('Opening modal, current state:', isModalOpen2);
    setIsModalOpen2(true);
  };

  const handleOk2 = () => {
    setIsModalOpen2(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };





  return (
    <>
      <Toast ref={toast} />
      <div className="space-y-6">
        {/* Form Header */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Create Your Account</h2>
          <p className="text-gray-600">Fill in your details to get started</p>
        </div>

        {/* Form Fields Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* First Name */}
          <div className="space-y-2">
            <label
              className="block text-sm font-semibold text-gray-700 mb-2"
              htmlFor="firstName"
            >
              First Name <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <InputText
                id="firstName"
                name="firstName"
                maxLength="40"
                className="w-full h-12 px-4 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white shadow-sm hover:border-gray-400"
                placeholder="Enter your first name"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>
            {err.firstName && (
              <div className="flex items-center space-x-1 mt-1">
                <span className="text-red-500 text-sm font-medium">
                  {err.firstName}
                </span>
              </div>
            )}
          </div>

          {/* Last Name */}
          <div className="space-y-2">
            <label
              className="block text-sm font-semibold text-gray-700 mb-2"
              htmlFor="lastName"
            >
              Last Name <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <InputText
                id="lastName"
                name="lastName"
                maxLength="40"
                className="w-full h-12 px-4 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white shadow-sm hover:border-gray-400"
                placeholder="Enter your last name"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
            {err.lastName && (
              <div className="flex items-center space-x-1 mt-1">
                <span className="text-red-500 text-sm font-medium">
                  {err.lastName}
                </span>
              </div>
            )}
          </div>

          {/* Date of Birth */}
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-700 mb-2" htmlFor="dob">
              Date of Birth <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <Calendar
                id="dob"
                value={formData.dob}
                onChange={handleDateChange}
                dateFormat="mm/dd/yy"
                placeholder="Please select your date of birth"
                className="w-full [&_.p-datepicker-trigger]:absolute [&_.p-datepicker-trigger]:right-3 [&_.p-datepicker-trigger]:top-1/2 [&_.p-datepicker-trigger]:transform [&_.p-datepicker-trigger]:-translate-y-1/2 [&_.p-datepicker-trigger]:text-gray-400 [&_.p-datepicker-trigger]:text-lg [&_.p-datepicker-trigger]:pointer-events-none"
                inputStyle={{ 
                  height: '48px',
                  border: '2px solid #d1d5db',
                  borderRadius: '8px',
                  padding: '0 48px 0 16px',
                  fontSize: '14px',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  width: '100%'
                }}
                maxDate={new Date()}
                showIcon
                readOnlyInput
              />
            </div>
            {err.dob && (
              <div className="flex items-center space-x-1 mt-1">
                <span className="text-red-500 text-sm font-medium">
                  {err.dob}
                </span>
              </div>
            )}
          </div>

          {/* Phone Number */}
          <div className="space-y-2">
            <label
              className="block text-sm font-semibold text-gray-700 mb-2"
              htmlFor="mobile"
            >
              Phone Number <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <InputText
                id="mobile"
                name="mobile"
                maxLength="10"
                className="w-full h-12 px-4 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white shadow-sm hover:border-gray-400 disabled:bg-gray-50 disabled:text-gray-500 disabled:border-gray-200"
                placeholder="Enter your phone number"
                value={formData.mobile}
                disabled={isValidMobile}
                onChange={handleChange}
                keyfilter="pnum"
              />
            </div>
            {err.mobile && (
              <div className="flex items-center space-x-1 mt-1">
                <span className="text-red-500 text-sm font-medium">
                  {err.mobile}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Consent Section */}
      <div className="mt-8 space-y-4">
        {/* Terms of Use consent */}
        <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg border-2 border-gray-200 hover:border-gray-300 transition-colors duration-200">
          <div className="flex-shrink-0">
            <Checkbox
              inputId="tcCheck"
              checked={tcCheck}
              onChange={(e) => settcCheck(e.checked)}
              className="border-2 border-gray-300 rounded focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
            />
          </div>
          <label htmlFor="tcCheck" className="text-sm text-gray-700 leading-relaxed cursor-pointer">
            I hereby accept and consent to be governed by these{" "}
            <span
              className="cursor-pointer text-blue-600 hover:text-blue-800 hover:underline font-semibold transition-colors duration-200"
              onClick={() => {
                console.log('Terms of Use clicked');
                setActiveTab("terms");
                showModal2();
              }}
            >
              Terms of Use
            </span>
          </label>
        </div>

        {/* Privacy Policy consent */}
        <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg border-2 border-gray-200 hover:border-gray-300 transition-colors duration-200">
          <div className="flex-shrink-0">
            <Checkbox
              inputId="privacyCheck"
              checked={privacyCheck}
              onChange={(e) => setPrivacyCheck(e.checked)}
              className="border-2 border-gray-300 rounded focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
            />
          </div>
          <label htmlFor="privacyCheck" className="text-sm text-gray-700 leading-relaxed cursor-pointer">
            I hereby accept and consent to be governed by these{" "}
            <span
              className="cursor-pointer text-blue-600 hover:text-blue-800 hover:underline font-semibold transition-colors duration-200"
              onClick={() => {
                console.log('Privacy Policy clicked');
                setActiveTab("privacy");
                showModal2();
              }}
            >
              Privacy Policy
            </span>
          </label>
        </div>
      </div>

      {/* Submit Button Section */}
      <div className="mt-8 space-y-4">
        <button
          onClick={signUp}
          disabled={isLoading}
          className="w-full h-12 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-[1.02] disabled:transform-none flex items-center justify-center space-x-2"
        >
          {isLoading && (
            <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
          )}
          <span>{isLoading ? "Creating Account..." : "Create Account"}</span>
        </button>

        {/* Login Link */}
        <div className="text-center">
          <span className="text-gray-600 text-sm">
            Already have an account?{" "}
            <button
              className="text-blue-600 hover:text-blue-800 font-semibold underline hover:no-underline transition-all duration-200"
              onClick={(e) => {
                props.loginfalse();
              }}
            >
              Log In
            </button>
          </span>
        </div>
      </div>

      {/* Terms and Privacy Modal */}
      <Dialog
        visible={isModalOpen2}
        onHide={handleCancel2}
        header=""
        modal
        className="w-full"
        style={{ width: modalWidth, height: `${vh * 98}px`, borderRadius: '12px', overflow: 'hidden' }}
        contentStyle={{ height: '90%', padding: '0' }}
      >
       
       

        {/* Tab Navigation */}
        <div className="flex border-b border-gray-200 bg-white">
          <button
            onClick={() => handleTabClick("terms")}
            className={`flex-1 py-4 px-6 text-center font-semibold transition-all duration-200 ${
              activeTab === "terms"
                ? "text-blue-600 border-b-2 border-blue-600 bg-blue-50"
                : "text-gray-600 hover:text-blue-600 hover:bg-gray-50"
            }`}
          >
            Terms and Conditions
          </button>
          <button
            onClick={() => handleTabClick("privacy")}
            className={`flex-1 py-4 px-6 text-center font-semibold transition-all duration-200 ${
              activeTab === "privacy"
                ? "text-blue-600 border-b-2 border-blue-600 bg-blue-50"
                : "text-gray-600 hover:text-blue-600 hover:bg-gray-50"
            }`}
          >
            Privacy Policy
          </button>
        </div>

        {/* PDF Content Container */}
        <div className="bg-white">
          {activeTab === "terms" && (
            <div className="h-96 md:h-[500px] relative">
              {consentInfo.tcPdf ? (
                <iframe
                  src={`${process.env.REACT_APP_IMG_BASEURL}${consentInfo.tcPdf}#toolbar=1&navpanes=1&scrollbar=1`}
                  width="100%"
                  height="100%"
                  className="border-0 rounded-b-lg"
                  title="Terms and Conditions"
                  onError={() => {
                    console.error('Failed to load Terms and Conditions PDF');
                  }}
                />
              ) : (
                <div className="flex flex-col items-center justify-center h-full bg-gray-50">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"></div>
                  <p className="text-gray-700 font-medium">Loading Terms and Conditions...</p>
                  <p className="text-sm text-gray-500 mt-2">Please wait while we fetch the latest terms.</p>
                </div>
              )}
            </div>
          )}

          {activeTab === "privacy" && (
            <div className="h-96 md:h-[500px] relative">
              {consentInfo.privacyPdf ? (
                <iframe
                  src={`${process.env.REACT_APP_IMG_BASEURL}${consentInfo.privacyPdf}#toolbar=1&navpanes=1&scrollbar=1`}
                  width="100%"
                  height="100%"
                  className="border-0 rounded-b-lg"
                  title="Privacy Policy"
                  onError={() => {
                    console.error('Failed to load Privacy Policy PDF');
                  }}
                />
              ) : (
                <div className="flex flex-col items-center justify-center h-full bg-gray-50">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"></div>
                  <p className="text-gray-700 font-medium">Loading Privacy Policy...</p>
                  <p className="text-sm text-gray-500 mt-2">Please wait while we fetch the latest privacy policy.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default SignupForm
